import { render, staticRenderFns } from "./PeixunshiList.vue?vue&type=template&id=5a3722ef&scoped=true&"
import script from "./PeixunshiList.vue?vue&type=script&lang=js&"
export * from "./PeixunshiList.vue?vue&type=script&lang=js&"
import style0 from "./PeixunshiList.vue?vue&type=style&index=0&id=5a3722ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3722ef",
  null
  
)

export default component.exports